// firebase.js - Enhanced with better error handling and browser detection

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Safely initialize messaging with proper error handling
let messaging = null;

// Check browser compatibility before initializing messaging
const checkMessagingSupport = async () => {
  try {
    const supported = await isSupported();
    return supported;
  } catch (error) {
    console.log("Error checking messaging support:", error);
    return false;
  }
};

// Initialize messaging only if supported
const initializeMessaging = async () => {
  try {
    const isMessagingSupported = await checkMessagingSupport();

    if (isMessagingSupported) {
      messaging = getMessaging(app);
      return true;
    }
    return false;
  } catch (error) {
    console.log("Error initializing Firebase messaging:", error);
    return false;
  }
};

// Initialize messaging right away but handle errors gracefully
(async () => {
  await initializeMessaging();
})();


// Enhanced FCM token generator with better error handling
const generateFCMToken = async (registration) => {
  if (registration == null) {
    return
  }
  try {
    // Check if browser supports FCM
    const isMessagingSupported = await checkMessagingSupport();

    if (!isMessagingSupported) {
      return false;
    }

    // Check notification permission
    if (Notification.permission === 'denied') {
      return false;
    }

    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      let token = localStorage.getItem('fcmToken');
      if (token) {
        return true;
      }

      // Ensure messaging is initialized
      if (!messaging) {
        const initialized = await initializeMessaging();
        if (!initialized) {
          console.log("Could not initialize Firebase messaging");
          return false;
        }
      }

      const tokenFromFirebase = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration
      });

      if (!tokenFromFirebase) {
        return false;
      }

      localStorage.setItem('fcmToken', tokenFromFirebase);
      return true;
    }

    return false;
  } catch (error) {
    console.log("Error in FCM token generation:", error);
    return false;
  }
};

// Safe method to get messaging instance
const getMessagingInstance = () => messaging;

export {
  app as default,
  auth,
  generateFCMToken,
  getMessagingInstance,
  checkMessagingSupport
};